import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ThemeService } from '@services/theme.service';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxScannerQrcodeComponent, NgxScannerQrcodeModule, NgxScannerQrcodeService, ScannerQRCodeConfig, ScannerQRCodeResult, ScannerQRCodeSelectedFiles } from 'ngx-scanner-qrcode';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  standalone: true,
  imports: [CommonModule, NgxScannerQrcodeModule, FormsModule, ReactiveFormsModule, TranslateModule]
})
export class InputComponent implements OnChanges {
  @Input() control: FormControl = new FormControl();
  @Input() type?: string = 'text';
  @Input() placeholder?: string = "Placeholder_input";
  @Input() label?: string;
  @Input() labelColor?: string = '#fff';
  @Input() bgColor?: string = '#fff';
  @Input() linkColor?: string = '#77B8DB';
  @Input() id?: string = 'input' + Date.now();
  @Input() disabled: boolean = false;
  @Input() error?: boolean = false;
  @Input() errorColor?: string = '#BB251A';
  @Input() errorMsg?: string = '';
  @Input() radius?: string = '0px';
  @Input() qr?: boolean = false;
  @Input() checkboxValue?: string = '1';
  @Input() listItems?: Array<{ key: string, value: any }> = []
  @Input() info?: string;
  @Input() maxLength?: number;

  @Output() checkStatus = new EventEmitter();
  @Output() clickInfo = new EventEmitter();

  showInfoModal = false;
  theme!: any;
  checked = false;
  isPassword = true;
  //QR Scaner
  started = false;
  @ViewChild('action') action!: NgxScannerQrcodeComponent;
  @ViewChild('native') native!: ElementRef;
  public config: ScannerQRCodeConfig = {
    constraints: {
      video: {
        width: window.innerWidth,
        facingMode: "environment",
      },
    },
    // canvasStyles: [
    //   { /* layer */
    //     lineWidth: 1,
    //     fillStyle: '#00950685',
    //     strokeStyle: '#00950685',
    //   },
    //   { /* text */
    //     font: '17px serif',
    //     fillStyle: '#ff0000',
    //     strokeStyle: '#ff0000',
    //   }
    // ],
  };

  public qrCodeResult: ScannerQRCodeSelectedFiles[] = [];

  public today: Date = new Date();
  public currentYear: number = this.today.getFullYear();
  public currentMonth: number = this.today.getMonth();
  public currentDay: number = this.today.getDate();
  public actualDate: string = this.currentYear + '-' + this.currentMonth + '-' + this.currentDay;

  constructor(private qrcode: NgxScannerQrcodeService, private themeService: ThemeService, private cdr: ChangeDetectorRef, private translateService: TranslateService) {
    this.themeService.getCurrentTheme().subscribe(theme => {
      this.theme = theme;
    });
  }

  ngOnChanges(changes: any): void {
    if (changes) {

    }
  }

  clickInfoEmit() {
    this.showInfoModal = !this.showInfoModal;
    this.clickInfo.emit(this.showInfoModal)
  }

  openDatepicker() {
    this.native.nativeElement.showPicker();
  }

  ngAfterViewInit(): void {
    this.action?.isReady.subscribe((res: any) => {
      // this.handle(this.action, 'start');
    });
  }

  closeModal(action?: any) {
    action.stop();
    this.started = false;
  }

  public onEvent(e: ScannerQRCodeResult[], action?: any): void {
    // e && action && action.pause();
    this.control.setValue(e[0].value);
    action.stop();
    this.started = false;
  }

  public handle(action: any, fn: string): void {
    const playDeviceFacingBack = (devices: any[]) => {
      // front camera or back camera check here!
      const device = devices.find(f => (/back|rear|environment/gi.test(f.label))); // Default Back Facing Camera
      action.playDevice(device ? device.deviceId : devices[0].deviceId);
    }

    if (fn === 'start') {
      this.started = true;
      action[fn](playDeviceFacingBack).subscribe((r: any) => console.log(fn, r), alert);
    } else {
      this.started = false;
      action[fn]().subscribe((r: any) => console.log(fn, r), alert);
    }
  }

  public checkboxClicked(): void {
    if (this.control.disabled) {
      return;
    }

    this.checked = !this.checked;
    this.control.setValue(this.checked);
    this.checkStatus.emit(this.checked);
  }

  /*Toggle pass*/
  public toggleShowPass() {
    this.isPassword = !this.isPassword;
  }

}
